fx.ns("shared", class BaseMain extends fx.Main {

	constructor(model) {
		super();

		// Laravel need X-CSRF-TOKEN for ajax calls, it's set in meta data.
		this.ajaxGlobalParameter("csrf-token", "X-CSRF-TOKEN");

		// we don't allow loading locally saved files
		if (window.location.href && window.location.href.indexOf("file://") == 0) {
			this.popup(new shared.popups.WarningOpenLocal(), { closeCurrent : true});
			this.lock();
			return;
		}

		// read land in url or in cookies
		fx.currentLang(Utils.getURLParam("fl-lang") ? Utils.getURLParam("fl-lang") : Cookies.get("fl-lang"));

		fx.set("quality", "light");
		fx.set("settings", new models.Settings());

		fx.set("previewMode", this.previewMode);
		//fx.set("checkUpload", this.checkUpload);
		fx.set("isAdmin", this.isAdmin);

		this.model = model;
		this.model.checkUpload = this.checkUpload();
		this.model.creationid = this.creationid;
		this.model.productid = this.productid;
		this.model.connectionid = this.connectionid;

		// At creation, try to get product params from Global variable set in page Flexilivre.product
		if (window.Flexilivre && window.Flexilivre.product) {
            this.model.product = window.Flexilivre.product;
			this.model.choosedShape = window.Flexilivre.product.shape;
			this.model.choosedFormat = window.Flexilivre.product.format_id;
			this.model.choosedCover = window.Flexilivre.product.option_id;
			this.model.themeid = window.Flexilivre.product.theme_id;
			this.model.choosedSize = window.Flexilivre.product.size;
			this.model.choosedThemeTag = window.Flexilivre.product.theme_tag_id;

            if (window.Flexilivre.product.hasFilteredPhoto)
                this.model.hasFilteredPhoto = window.Flexilivre.product.hasFilteredPhoto;

			// ATTENTION : window.Flexilivre.product.option exists only at creation
			if (window.Flexilivre.product.option)
				this.model.creationProductOption = window.Flexilivre.product.option;

		}
		else // otherwise try to get them from url
		{
			this.model.choosedFormat = Utils.getURLParam("format");
			this.model.choosedShape = Utils.getURLParam("shape");
			this.model.choosedCover = Utils.getURLParam("cover");
			this.model.choosedSize = Utils.getURLParam("size");
			this.model.choosedThemeTag = Utils.getURLParam("themetag");
			this.model.themeid = Utils.getURLParam("themeid");
		}

		this.on("global-error", this._handleGlobalError, new shared.ErrorHandling());

		this.switchEffect = "fade";
	}

	get productid() {
		if (!this._productid) {
			if (fx.browser.urlPathParts[0] == "create") {
				this._productid = window.Flexilivre.product.id;
				//this._productid = (fx.browser.hashParameter("creation") || fx.browser.urlPathParts[1]);
				//this._productid = Utils.isNumber(this._productid) ? Number(this._productid) : undefined;
			}
		}
		return this._productid;
	}

	get isProductCollection() {
		if (window.Flexilivre.product)
			return !!window.Flexilivre.product.use_media;
		else
			if (this.model.creation)
				return !!this.model.creation.useMedias;
			else
				return false;
	}

	get creationid() {
		if (!this._creationid) {
			this._creationid = (fx.browser.hashParameter("creation") || fx.browser.urlPathParts[0]);
			this._creationid = Utils.isNumber(this._creationid) ? Number(this._creationid) : undefined;
		}
		return this._creationid;
	}

	get secondUrlParameter() {
		return fx.browser.urlPathParts[2]
	}

	/*get isBox() {
		if (this.model.productOption)
			return this.model.productOption.code.toLowerCase().startsWith("box-");
	}*/

	/*get isFrame() {
		if (this.model.productOption)
			return this.model.productOption.finition.toLowerCase().startsWith("cadre");
	}*/

	get urlExit() {
		return Utils.getURLParam("urlExit") || "/account/";
	}

	get isAdmin() {
		return Utils.getURLParam("admin");
	}

	get connectionid() {
		return Utils.getURLParam("connectionid") || Cookies.get("connectionid");
	}

	get previewMode() {
		return !!Utils.getURLParam("preview"); //  creation open for preview before adding to cart
	}

	/*get optionsMode() {
		return !!Utils.getURLParam("options"); //  creation open for options edit before adding to cart
	}*/

	checkUpload() {
		let checkUpload = Utils.getURLParam("checkupload");
		return checkUpload && (checkUpload === "true" || checkUpload === true) ? true : false;
	}

	getCreationParamsFromUrl() {
		let choices = {
			chosen_shape: Utils.getURLParam("shape"),
			chosen_format: Utils.getURLParam("format"),
			chosen_cover: Utils.getURLParam("cover"),
			chosen_size: Utils.getURLParam("size"),
			chosen_theme_tag: Utils.getURLParam("themetag")
		};

		return choices;
	}

	onDataEvent(e) {
		super.onDataEvent(e);

		switch (e.type) {

            // Save Error
            case "save-creation-error":

                // 3 tries ?

				if (this.currentView == "Saving") {
					this.popup(new shared.popups.SaveBookError(e.model), { closeCurrent : true});// TESTED
					this.model.event("show-editor");
				}
				break;

            case "files-not-uploaded":
				if (this.flutterExitCreation && this.flutterExitCreation.shouldSkipFilesNotUploadedPopup())
					break;

				this.popup(new shared.popups.FileNotUploaded(e.data, this.model), { closeCurrent : true});
				break;


			case "back":
				this.actionRequested = "";
				this.back();
				break;

			case "offline":
				this.popup(new shared.popups.Offline())
				break;

			case "online":
				this.popup(null);
				break;

			//--- Navigation

			case "navigate-order":
				let optionIds = [];
				if (this.model.selectedOptions && this.model.selectedOptions.length > 0) {
					for (let i = 0; i < this.model.selectedOptions.length; i++) {
						optionIds.push(this.model.selectedOptions[i]._data);
					}
				}
				this.navigateToURL("/order/add?type=" + this.model.creation.productType + "&id=" + this.model.creation.id + "&options=" + optionIds.join(","));
				break;

			case "navigate-exit":
				this.navigateToURL(this.urlExit);
				break;

			case "navigate-back":
				this.navigateBack();
				break;

			case "reload-page":
				this.reloadPage();
				break;


			/***************** Register / Login popups ************/

            case "creation-loaded":
            case "creation-created":
				if (this.model.checkUpload && fx.get("flutter")) {
					fx.get("flutter").CheckUpload(this.creationid);
				}

                /*if (fx.get("mode") != "creating-ia" && (!this.model.creation || !this.model.creation.filteredPhoto))
                    fx.service("FaceService").init();*/
				
				if (!this.model.account.isRegistered && !this.model.creation.suspended)
					this.model.event("propose-register", null, fx.get("settings").delayProposeRegister);
				break;

			case "save-creation":
				this.model.save(this.actionRequested);
				break;

			case "creation-saving":
				if (this.actionRequested && this._canResumeLeavingAfterSave() && !this.hasPopup)
					this.model.event("screen-saving");
				break;

			case "creation-saved":
				if (this.flutterExitCreation && this.flutterExitCreation.handleCreationSaved())
					break;

                if (!this.isInSteps())
                {
                    if (this.actionRequested && this._canResumeLeavingAfterSave())
                        this.model.event(this.actionRequested);
                    else
                        if (this.currentView == "Saving")
                            this.model.event("show-editor");
                }
				break;


			case "propose-register":
				if (!this.model.account.isRegistered)
                {
                    if (!this.hasPopup)
                    {
                        if (this.actionRequested == "order-confirmed")
                            this._showAuth("register", () => this.popup(new shared.popups.RegistrationPopup(e.model)));
                        else
						    this.popup(new shared.popups.ProposeRegister(e.model, this.actionRequested == "exit-editor"));
                    }
                    else
                    {
                        this.model.event("propose-register", null, fx.get("settings").delayProposeRegister);
                    }
				}
				break;

			case "confirm-delete-photo":
                this.popup(new shared.popups.ConfirmDeletePhoto(e.data))
				break;

			case "magic-eraser":
				this.popup(new shared.popups.MagicEraserPopup(e.detail, this.model));
				break;

			case "refused-register":
				// ProposeRegister lingers under the flutter auth modal ; a later popup
				// swap closes it and fires this. Once registered it is not a refusal —
				// clearing actionRequested here drops the pending save/exit mid-flight.
				if (this.model.account.isRegistered)
					break;
				this.actionRequested = "";
				this.model.event("propose-register", null, fx.get("settings").delayProposeRegister);
				break;

			case "register-user":
				this._showAuth("register", () => this.popup(new shared.popups.RegistrationPopup(this.model), { closeCurrent : true}));
				// outside the closure : the flutter modal does not run it, and the
				// nag must be re-armed there too (it defers itself while a popup
				// or the modal is up)
				this.model.event("propose-register", null, fx.get("settings").delayProposeRegister);
				break;

			case "show-conditions":
				this.navigateToURL(window.location.origin + "/cgu/", true);
				break;

			case "login-popup":
				this._showAuth("login", () => this.popup(new shared.popups.LoginPopup(this.model), { closeCurrent : true}));
				break;

			//case "login-succeed":
			case "login-complete":
				if (this.model.creation && this.model.creation.cover)
					this.model.creation.cover.modified = true;

				if (this.actionRequested)
					this.model.event(this.actionRequested, 10); // we add a delay to let time for updates
				break;

			//case "register-succeed":
			case "register-complete":
				if (this.model.creation && this.model.creation.cover)
					this.model.creation.cover.modified = true;

				if (this.actionRequested)
					this.model.event(this.actionRequested, 10); // we add a delay to let time for updates
				else
					this.popup(new shared.popups.RegisteredPopup(), { closeCurrent : true});

				break;


			case "new-editor-opened":

				if (this._newEditorOpenenedWarning)
					return;

				this._newEditorOpenenedWarning = true;

				this.popup(new shared.popups.NewEditorOpened(this.model), { closeCurrent : true});

				break;


			/************** Errors popups ****************/

			case "create-creation-error":
				this.popup(new shared.popups.CreateBookError(e.model), { closeCurrent : true});
				break;

			case "server-error":
			case "load-backgrounds-error":
			case "load-stickers-error":
			case "load-texts-error":
			case "load-products-error":
			case "load-covers-error":
			case "save-text_thumb-error":
			case "save_theme_thumb-error":
			case "get_theme_layout-error":
			case "copy-layouts-error":
			case "save-model-error":
			case "load-model-error":
			case "save-layout-error":
			case "load-creation-options-error":
			case "save-layouts-error":
			case "thumb-layouts-saved-error":
			case "text-thumb-save-error":
			case "album-photos-copy-error":
			case "album-photos-error":
			case "albums-error":
				this.popup(new shared.popups.ServerError(e.model), { closeCurrent : true});
				break;

			case "load-creation-error":
				this.handleLoadError(e.data)
				break;

			case "albums-error":
				this.popup(new shared.popups.ErrorAlbums()); // TESTED
				break;

			case "google-selected-photos-error":
				this.popup(new shared.popups.GooglePhotosError(e.model));  // TESTED
				break;

			case "load-layout-medias-error":
				this.popup(new shared.popups.LoadLayoutMediasError(e.model), { closeCurrent : true});// TESTED
				this.model.event("show-editor");
				break;

			case "file-conversion-error":
				this.popup(new shared.popups.FileConversionError(e.model), { closeCurrent : true}); // TESTED
				break

			case "get-imported-file-error":
				this.popup(new shared.popups.LoadImportedFilesError(e.model), { closeCurrent : true});  // TESTED
				break

			case "load-recommended-sticker-error":
			case "load-recommended-background-error":
			case "update-url-error":
				// nothing do thing, need only log
				break;
			case "upload-finished":
                if (this.model.photos && this.model.photos.reaffecting) return;

				if (this.actionRequested && (!this.flutterExitCreation || this.flutterExitCreation.isWaitingForWebviewUploads))
					this.model.event(this.actionRequested, 250);  // we add a delay to let time for updates
				break;

			// print, poster and calendar never clear it : the leave would fire later
			case "upload-progress-closed":
				if (this.flutterExitCreation)
					this.actionRequested = "";
				break;
			case "upload-file":
			case "upload-error":
			case "media-file-uploaded":
			case "upload-file-progress":
				//case "upload-finished" :
				/*document.title = "Flexilivre"; TODO
				if(!fx.service("AIService").processing && fx.service("MediasUploader").uploading)
					document.title += " " + parseInt(fx.service("MediasUploader").position * 100 / fx.service("MediasUploader").total) + "%";*/
				break;

            case "reaffecting-complete" : 
                if (this.actionRequested)
					this.model.event(this.actionRequested, 250);  // we add a delay to let time for updates
                break;

            case "ai-filter-failed":
                this.popup(new shared.popups.ServerError(e.model, fx.text("Votre photo n'a pu être transformée, veuillez re-éssayer dans quelques instants."), false), { closeCurrent : true});
				break;
			// AI
			case "connection-error": // themes not loaded
				this.popup(new shared.popups.ServerError(e.model), { closeCurrent : true});
				break;

			case "theme-layouts-error":
				this.popup(new shared.popups.ServerError(e.model), { closeCurrent : true});
				break;

			// --- Photo import screen (SelectPhotosPanel), shared by every product and every source.
			// import-mobile / mobile-upload-started / -send exist in every mode, so they are NOT
			// switched here (a product calls _startMobileImport()/_showMobileImport() from its own
			// onDataEvent in the standard case, keeping its special modes). import-photos-* are only
			// fired by the panel (always standard), so they are handled here for every product. ---

			// the picker opened by itself : the receiving screen goes up behind it, so the customer comes
			// back to their photos arriving instead of to a sign-in panel
			case "google-picker-opened":
			// the picker is closed : the same screen shows the photos as they are fetched
			case "google-selected-photos":
				this._startGoogleImport();
				break;

			case "import-photos-validated":
				// still receiving : confirm importing only what has arrived so far
				if (this.importSource && this.importSource.pending)
					this.popup(new shared.popups.ConfirmEarlyImport(this.model, this.importSource.receivedPhotos.length, this.importSource.confirmEarly));
				else
					this._importPhotos();
				break;

			// confirmed importing before the end : keep what arrived, drop the rest
			case "import-photos-early":
				this._importPhotos();
				break;

			case "import-photos-cancelled":
				this._cancelImport();
				break;
		}

		/*if (e.type.endsWith("-error"))
			this.errorHandling.log(e.detail, "ajax");*/
	}

	/**
	* The service feeding the import screen. An import source exposes receivedPhotos (an fx.ModelArray
	* also added to the album), pending, stop(), importedEvent and confirmEarly { title, text }.
	* SmsService (phone upload) and GoogleService both implement it.
	*/
	get importSource() {
		return this._importSource ? fx.service(this._importSource) : null;
	}

	// import-mobile : open the receiving screen and the phone popup, and keep receiving after
	// "finished" so the user can send more while the screen is up. `options` are forwarded to the
	// panel so a product can override its validate action or wording (see SelectPhotosPanelBase).
	_startMobileImport(options = null) {
		fx.service("SmsService").continuous = true;
		this._importSource = "SmsService";
		this.switchTo("SelectPhotosPanel", this._mobileImportData(options));
		this.popup(new shared.popups.EnterPhoneNumber(this.model));
	}

	// the same screen, fed by the Google import ; the sign-in popup has done its job. Unlike the phone
	// upload, this one can start from within a creation wizard, hence the return view below.
	_startGoogleImport() {
		this._importSource = "GoogleService";

		// called twice now : once when the picker opens, once when the photos come back from it. Switching
		// again would rebuild the screen and lose what has arrived, and would make "Quitter" come back to
		// this very panel.
		if (this.currentView == "SelectPhotosPanel") {
			this.popup(null);
			return;
		}

		// where "Quitter" goes back to. _switchTo, not switchTo : the public one drops a wizard's steps
		this._importReturnView = this.currentView;

		this.popup(null);
		this._switchTo("SelectPhotosPanel", this._googleImportData());
	}

	// "Quitter" : drop the photos and go back where the import started, or to the editor
	_cancelImport() {
		let back = this._importReturnView;

		this._discardPhotos();

		if (back && back != "SelectPhotosPanel")
			this._switchTo(back, null, null, "previous");
		else
			this.model.event("show-editor");
	}

	// mobile-upload-started / -send (standard) : make sure the receiving screen is up, close the popup
	_showMobileImport() {
		this._importSource = "SmsService";

		if (this.currentView != "SelectPhotosPanel")
			this.switchTo("SelectPhotosPanel", this._mobileImportData());
		this.popup(null);
	}

	// what the SelectPhotosPanel is opened with for the "send photos from a phone" flow : just the
	// creation model and the photos the SmsService receives. The wording lives in the panel's defaults
	// (same for every product for now) ; pass `options` to override it for another flow later.
	_mobileImportData(options = null) {
		let data = {
			model : this.model,
			photos : fx.service("SmsService").receivedPhotos
		};

		// merged, not assigned : a product can pass its own options (poster passes validateEvent) and
		// must not lose the total the phone announces
		data.options = Object.assign({ totalEvent : "mobile-upload-total" }, options || {});

		return data;
	}

	// the same screen, fed by the Google import ; its wording lives with the panel's own defaults
	_googleImportData() {
		return {
			model : this.model,
			photos : fx.service("GoogleService").receivedPhotos,
			options : { source : "google" }
		};
	}

	// "Importer" (or a confirmed early import) : the photos are already in the album, just stop and go
	_importPhotos() {
		let source = this.importSource;

		if (!source)
			return;

		// read before clearing : the products branch on how many came in
		let photos = source.receivedPhotos.toArray();

		source.stop();
		source.receivedPhotos.removeAll(true);
		this._importSource = null;
		this._importReturnView = null;

		this.model.event(source.importedEvent, photos);
	}

	// the photos were added to the album as they arrived, so they are removed here
	_discardPhotos() {
		let source = this.importSource;

		if (!source)
			return;

		source.stop();

		let received = source.receivedPhotos;
		this._importSource = null;
		this._importReturnView = null;

		if (!received)
			return;

		// the received photo IS the album's Photo instance (same object added to both), so delete it
		// directly : it removes itself from the album and bubbles to the creation
		for (let i = 0; i < received.length; i++)
			received.getItemAt(i).delete();

		received.removeAll(true);
	}

	// fx.Main only tracks popups opened through popup(), so the flutter auth modal
	// is invisible to it. Folded in here to keep every consumer right.
	get hasPopup() {
		let flutter = fx.get("flutter");
		return super.hasPopup || !!(flutter && flutter.authOpen);
	}

	// Flutter applies the result itself ; web and apps <= 1.4.2 use the JS popup.
	_showAuth(mode, showJsAuth) {
		let flutter = fx.get("flutter");
		if (flutter && flutter.supportsFlutterAuth())
			flutter.ShowAuth(mode, { creationid: this.model.creation.id, accountid: this.model.account.id });
		else
			showJsAuth();
	}

	readyLeaving(action) {
		let flutterExit = this.flutterExitCreation;
		if (flutterExit)
			flutterExit.startExit(action);

		this.actionRequested = action;

		this.model.checkUploadedPhotos();

		if (fx.service("PdfUploader").converting)
			fx.service("PdfUploader").askNotification();

		if (!this.model.account.isRegistered)
			this.model.event("propose-register");
		else if (this._uploadsBlockLeaving(true)) // SO far only google, since FB and Instagram disabled
		{
			if (flutterExit)
				flutterExit.waitForWebviewUploads();

			this.model.event("upload-progress");
		}
		else if (flutterExit)
			return flutterExit.continueExit();
		else if (this.model.modified)
			this.model.event("save-creation");
		else
			return true;
	}

	onLeave(e) {
		let uploading = this._uploadsBlockLeaving();

		if ((this.model.account && this.model.account.isRegistered && this.model.creation && this.model.creation.id && this.model.modified) || uploading) {
			e.cancel = true;

			if (uploading)
				this.model.event("upload-progress");
		}

		super.onLeave(e);
	}

	// Set by the app when it uploads in the background (bgupload=1), null otherwise.
	get flutterExitCreation() {
		let flutter = fx.get("flutter");
		return flutter ? flutter.exitCreation : null;
	}

	// Legacy : each call site's historical check. App exit : webview uploads only.
	_uploadsBlockLeaving(withGoogle) {
		if (this.flutterExitCreation)
			return this.flutterExitCreation.isWebviewUploading;

		return fx.service("MediasUploader").uploading || (!!withGoogle && fx.service("GoogleService").processing);
	}

	_canResumeLeavingAfterSave() {
		return this.flutterExitCreation ? this.flutterExitCreation.canResumeExitAfterSave() : !this._uploadsBlockLeaving();
	}

	_handleGlobalError(e) {
		if (e.detail.msg && (e.detail.msg.indexOf("Mémoire insuffisante") > -1 || e.detail.msg.indexOf("out of memory") > -1))
			this.popup(new shared.popups.ErrorInsufficientMemory(), { closeCurrent : true})
	}


	handleLoadError(error) {
		switch (error) {
			case "NO_PAGES":
			case "CREATION_DELETED":
			case "NO_CURRENT_USER":
				this.popup(new shared.popups.LoadCreationError(this.model), { closeCurrent : true});  // TESTED
				break;

			case "NOT_ALLOWED":
			case "NO_CREATION":
			case "OBSOLETE_BROWSER":
				this.model.event("navigate-exit");
				break;
		}
	}


});